import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=05e5ae40&scoped=true"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5ae40",
  null
  
)

export default component.exports